import React from 'react';
import { Container, Typography } from '@mui/material';
import logo from '../img/ineligible.png'
import SubmitButton from '../components/Button'

const Ineligible = () => {
    const containerStyle = {
        textAlign: 'center',
        paddingTop: '10vh',
        height: '100vh'
    };

    const imageStyle = {
        width: '200px',
        height: 'auto',
    };

    const applicationLink = 'https://workflow.transflowitc.com/formfilling/3e189cb2-1c64-43f9-8377-0020bd5238a2';


    return (
        <Container style={containerStyle}>
            <img src={logo} alt="No Courses Available" style={imageStyle} />
            <Typography variant="h6" component="h6" style={{ color: '#DE2121', marginTop: '20px' }}>
                You didn't meet the eligibility criteria for a degree program, but your dream is still within reach!
            </Typography>
            <Typography variant="body1" component="p" style={{ color: '#666', marginTop: '10px' }}>
                Take the next step with our ATHE Diploma Program, an internationally recognised qualification that opens the door to future degree programs.
            </Typography>

            <SubmitButton link={applicationLink} text="START YOUR SUCCESS JOURNEY - ATHE APPLICATION FORM 2025/2026"/>
        </Container>
    );
};

export default Ineligible;
